export function clearQueryParams(...keys: string[]): boolean {
  const params = new URLSearchParams(location.search);
  const prev = params.toString();

  keys.forEach((k) => params.delete(k));

  const next = params.toString();
  if (next !== prev) {
    const newUrl = location.pathname + (next ? `?${next}` : '') + location.hash;
    history.replaceState({}, document.title, newUrl);
    return true;
  }

  return false;
}
